import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchBalanceBillingClaimStatusStarted = () => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_CLAIM_STATUS_STARTED,
  };
};

export const fetchBalanceBillingClaimStatusSuccess = (
  balanceBillingClaimStatus
) => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_CLAIM_STATUS_SUCCESS,
    balanceBillingClaimStatus: balanceBillingClaimStatus,
  };
};

export const fetchBalanceBillingClaimStatusFailed = () => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_CLAIM_STATUS_FAILED,
  };
};

export const fetchBalanceBillingClaimStatus = (claimId: number) => {
  return (dispatch) => {
    dispatch(fetchBalanceBillingClaimStatusStarted());
    axios
      .get(serverconfigs.fetchBalanceBillingClaimStatusUrl+`/${claimId}`)
      .then((response) => {
        console.log(response.data);
        dispatch(
          fetchBalanceBillingClaimStatusSuccess(response.data.result[0])
        );
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchBalanceBillingClaimStatusFailed());
      });
  };
};
